module.exports = __webpack_public_path__ + "img/2e434b45fdbf3ea1d2676d3270ad8877221aefd1.80a59dab.png";